interface CategoryTabsProps {
  categories: string[];
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

export default function CategoryTabs({ categories, activeCategory, onCategoryChange }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide px-4 md:px-6" role="tablist">
      <div className="flex items-center bg-background-100 rounded-full px-1 py-1">
        {categories.map((category) => (
          <button
            key={category}
            role="tab"
            aria-selected={activeCategory === category}
            onClick={() => onCategoryChange(category)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              activeCategory === category
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-600 hover:text-foreground-800 hover:bg-background-200/70'
            }`}
          >
            {category}
          </button>
        ))}
      </div>
    </div>
  );
}